const basePath = 'workspace/classroom'
export const ROUTER_WORKSPACE_CLASS_ROOM = {
	root: `/${basePath}`,
	detail: id => `/${basePath}/${id || ':id'}`,
	feature_detail: `/${basePath}/:id/:feature/:feature_id`
}

export const TRANSLATE_WORKSPACE_CLASS_ROOM = `${basePath}`
